<div class="bg-template bg-img"></div>
<div class="view">
  <div class="card">
    <div class="container">
      <h1>{{ title }}</h1>
      @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <app-success-message [message]="success" class="status-message"></app-success-message>
      <app-error-message [message]="error" class="status-message"></app-error-message>
      <ng-content></ng-content>
    </div>
  </div>
</div>
